import React, { useState } from "react";
import ProductForm from "../components/product/ProductForm";
import ProductList from "../components/product/ProductList";
import { getProductById } from "../components/product/productService";


function ProductPage() {
  const [editData, setEditData] = useState(null);
  const [showForm, setShowForm] = useState(false);

  const handleAddClick = () => {
    setEditData(null);
    setShowForm(true);
  };

  const handleEdit = async (id) => {
    try {
      const res = await getProductById(id);
      setEditData(res.data);   // ✅ full product with variants
      setShowForm(true);
    } catch (error) {
      console.error("Error loading product:", error);
    }
  };

  const handleBack = () => {
    setEditData(null);
    setShowForm(false);
  };

  return (
    <div className="container mt-4">

      {!showForm ? (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>Product Management</h4>
            <button className="btn btn-primary" onClick={handleAddClick}>
              + Add Product
            </button>
          </div>

          <ProductList onEdit={handleEdit} />
        </>
      ) : (
        <>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h4>{editData ? "Edit Product" : "Add Product"}</h4>
            <button className="btn btn-secondary" onClick={handleBack}>
              ← Back to List
            </button>
          </div>

          <ProductForm
            editData={editData}
            refreshList={handleBack}
            clearEdit={handleBack}
          />
        </>
      )}
    </div>
  );
}

export default ProductPage;